import axios from 'axios'

// 门户请求封装：门户接口公开无需 token，统一错误提示
const request = axios.create({
  baseURL: '/api',
  timeout: 15000
})

request.interceptors.response.use(
  (response) => {
    const res = response.data
    if (res.code === 200) {
      return res.data
    }
    const isEn = localStorage.getItem('locale') === 'en-US'
    console.error(isEn ? 'API error:' : '接口错误:', res.message)
    return Promise.reject(new Error(res.message || (isEn ? 'Request failed' : '请求失败')))
  },
  (error) => {
    const isEn = localStorage.getItem('locale') === 'en-US'
    console.error(isEn ? 'Network error:' : '网络错误:', error.message)
    return Promise.reject(error)
  }
)

export default request
